// extracted by mini-css-extract-plugin
export var Body = "styles-module--Body--ARjET";
export var Footer = "styles-module--Footer--uVJNx";
export var Login = "styles-module--Login--o+DCS";
export var Message = "styles-module--Message--LWQV2";
export var Wrapper = "styles-module--Wrapper--xhiuY";